import { CLEAR_PRODUCTS } from "./types";

export default () => {
    return { type: CLEAR_PRODUCTS }
}
